<template>
    <div class="plain">
        <slot />
    </div>
</template>
